import React from "react";
import { Heart, ArrowRight } from "lucide-react";

export default function CTAFooter() {
  const scrollToForm = () => {
    document.getElementById("preorder")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* Red CTA banner */}
      <section className="bg-[#990EE5]">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-5 py-8 md:px-8 lg:flex-row lg:justify-between">
          <div className="flex items-center gap-5">
            <Heart className="h-12 w-12 shrink-0 text-white/90" strokeWidth={1.6} />
            <div>
              <h2 className="font-serif-display text-3xl font-bold text-white">
                Don't Miss Out!
              </h2>
              <p className="mt-1 text-[15px] text-white/90">
                Reserve your copy now and be the first to read it.
              </p>
            </div>
          </div>
          <button
            onClick={scrollToForm}
            className="group flex items-center gap-3 rounded-full bg-white px-8 py-4 font-serif-display text-sm font-extrabold tracking-wide text-[#990EE5] shadow-md transition-all hover:shadow-lg active:scale-[0.98]"
          >
            YES! I WANT MY COPY
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#3d0b7a]">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-5 py-6 text-center md:flex-row md:justify-between md:px-8 md:text-left">
          <p className="text-[13px] text-white/70">
            © 2024 The Motivated Parents & Educators. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a href="#top" className="text-[13px] text-white/80 transition-colors hover:text-white">
              Privacy Policy
            </a>
            <a href="#top" className="text-[13px] text-white/80 transition-colors hover:text-white">
              Terms of Use
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
